import { StoreProvider } from 'easy-peasy';
import { Provider } from 'jotai';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { processSSRData } from './model/ssr-data/ssr-data';
import store from './store';
// import JotaiDevTools from './store/JotaiDevTools';
import { jotaiStore } from './store/store';

// import { scan } from 'react-scan';
// scan({
//     enabled: true,
// });

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

// Pre-populate state from SSR before first render/hydration
try {
    processSSRData();
} catch (err) {
    console.warn('[SSR] Failed to pre-process SSR data before hydration', err);
}

const appTree = (
    <StoreProvider store={store}>
        <Provider store={jotaiStore}>
            {/* <JotaiDevTools /> */}
            <App />
        </Provider>
    </StoreProvider>
);

// if (container.hasChildNodes()) {
// Hydrate server-rendered markup (PostTab only)
// hydrateRoot(container, appTree);
// } else {
createRoot(container).render(appTree);
// }
